var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isYouhuiPopshow)?_c('div',{staticClass:"toVipYouhuiPOp",on:{"click":_vm.toPayVip}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toVipPopBottom"},[_vm._v("\n        永久会员"),_c('br'),_vm._v("\n        即将下架\n\n        "),_c('div',{staticClass:"toVipIMg"},[_c('img',{staticClass:"upVipICimg",attrs:{"src":require("./images/upVipIC.gif"),"alt":""}})])])
}]

export { render, staticRenderFns }